import React, { useState } from "react";
import { useBookings } from "../context/BookingContext";

export default function Book() {
  const { createCallback } = useBookings() || {};
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [thankYouMessage, setThankYouMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.number.trim()) {
      newErrors.number = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.number.trim())) {
      newErrors.number = "Must be 10 digits";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setIsSubmitting(true);
      if (createCallback) {
        await createCallback(formData.name, formData.email, formData.number);
      }
      setIsSubmitting(false);
      setThankYouMessage(
        `Thank you ${formData.name}! Our royal concierge will call you at ${formData.number} within 5 minutes.`
      );
      setFormData({ name: "", email: "", number: "" });
    }
  };

  return (
    <section 
      className="hk-callback-section py-2 py-md-3 m-0" 
      style={{ background: "linear-gradient(180deg, #FAF6F0 0%, #F2EAE0 50%, #FAF6F0 100%)" }} 
      aria-label="Priority Callback Request"
    >
      <div className="container" style={{ maxWidth: "1140px" }}>
        <div className="hk-callback-card">
          {!thankYouMessage ? (
            <form onSubmit={handleSubmit} noValidate>
              <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom border-secondary-subtle">
                <div className="d-flex align-items-center gap-2">
                  <i className="fas fa-phone-volume text-warning" style={{ fontSize: "1rem", color: "#FEA116" }}></i>
                  <h3 className="m-0 h6 font-weight-bold text-uppercase" style={{ color: "#0B1D37", fontFamily: "'Cinzel', serif", letterSpacing: "0.05em", fontSize: "0.85rem" }}>
                    Request Priority Concierge Callback
                  </h3>
                </div>
                <span className="d-none d-md-inline-block text-muted" style={{ fontSize: "0.75rem", color: "#53647C" }}>
                  <i className="fas fa-bolt me-1" style={{ color: "#FEA116" }}></i> Instant 5-Min Response
                </span>
              </div>

              <div className="hk-callback-grid">
                {/* Field 1: Name */}
                <div className="hk-field-group">
                  <div className={`hk-input-wrapper ${errors.name ? "hk-has-error" : ""}`}>
                    <i className="fas fa-user hk-field-icon"></i>
                    <input
                      type="text"
                      className="hk-field-input"
                      placeholder="Full Name *"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      aria-label="Full Name"
                    />
                  </div>
                  {errors.name && <span className="hk-field-error-badge"><i className="fas fa-exclamation-circle me-1"></i>{errors.name}</span>}
                </div>

                {/* Field 2: Email */}
                <div className="hk-field-group">
                  <div className={`hk-input-wrapper ${errors.email ? "hk-has-error" : ""}`}>
                    <i className="fas fa-envelope hk-field-icon"></i>
                    <input
                      type="email"
                      className="hk-field-input"
                      placeholder="Email Address *"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      aria-label="Email Address"
                    />
                  </div>
                  {errors.email && <span className="hk-field-error-badge"><i className="fas fa-exclamation-circle me-1"></i>{errors.email}</span>}
                </div>

                {/* Field 3: Phone */}
                <div className="hk-field-group">
                  <div className={`hk-input-wrapper ${errors.number ? "hk-has-error" : ""}`}>
                    <i className="fas fa-phone hk-field-icon"></i>
                    <input
                      type="tel"
                      className="hk-field-input"
                      placeholder="10-Digit Phone *"
                      name="number"
                      value={formData.number}
                      onChange={handleChange}
                      aria-label="Phone Number"
                    />
                  </div>
                  {errors.number && <span className="hk-field-error-badge"><i className="fas fa-exclamation-circle me-1"></i>{errors.number}</span>}
                </div>

                {/* Submit Button */}
                <div className="hk-field-group hk-button-group">
                  <button type="submit" className="hk-callback-btn" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Requesting...
                      </>
                    ) : (
                      <>
                        Request Priority Callback
                        <i className="fas fa-arrow-right ms-2" style={{ fontSize: "0.82rem" }}></i>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <div className="hk-thank-box text-center py-2 animate-fade-in">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2" style={{ width: "38px", height: "38px", background: "rgba(254, 161, 22, 0.15)", border: "1.5px solid #FEA116", color: "#FEA116" }}>
                <i className="fas fa-check" style={{ fontSize: "1.1rem" }}></i>
              </div>
              <h4 className="hk-thank-title h6 m-0 mb-1" style={{ color: "#0B1D37" }}>{thankYouMessage}</h4>
              <p className="hk-thank-sub m-0 text-muted" style={{ fontSize: "0.82rem", color: "#53647C" }}>
                Thank you for choosing HariKunj Resort Jodhpur. Our team will contact you shortly!
              </p>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .hk-callback-section {
          position: relative;
          z-index: 15;
        }

        .hk-callback-card {
          background: #FFFFFF;
          padding: 16px 20px;
          border-radius: 20px;
          box-shadow: 0 12px 32px rgba(11, 29, 55, 0.08);
          border: 1.5px solid rgba(212, 175, 55, 0.45);
          width: 100%;
        }

        .hk-callback-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr auto;
          gap: 12px;
          align-items: start;
        }

        .hk-field-group {
          display: flex;
          flex-direction: column;
          position: relative;
        }

        .hk-input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
        }

        .hk-field-icon {
          position: absolute;
          left: 14px;
          color: #FEA116;
          font-size: 0.88rem;
          pointer-events: none;
          z-index: 2;
          transition: color 0.3s ease;
        }

        .hk-field-input {
          width: 100%;
          height: 42px;
          padding: 0 14px 0 40px;
          border-radius: 10px;
          border: 1.5px solid rgba(212, 175, 55, 0.35);
          background: #FAF6F0;
          color: #0B1D37;
          font-size: 0.88rem;
          font-family: 'Poppins', sans-serif;
          transition: all 0.3s ease;
        }

        .hk-field-input::placeholder {
          color: #778899;
        }

        .hk-field-input:focus {
          outline: none;
          border-color: #FEA116;
          background: #ffffff;
          box-shadow: 0 0 14px rgba(254, 161, 22, 0.25);
        }

        .hk-has-error .hk-field-input {
          border-color: #ef4444 !important;
          background: rgba(239, 68, 68, 0.08) !important;
        }

        .hk-field-error-badge {
          display: inline-flex;
          align-items: center;
          margin-top: 4px;
          padding: 2px 6px;
          background: rgba(239, 68, 68, 0.15);
          border: 1px solid rgba(239, 68, 68, 0.35);
          border-radius: 6px;
          color: #dc2626;
          font-size: 0.75rem;
          font-weight: 500;
        }

        .hk-callback-btn {
          height: 42px;
          padding: 0 24px;
          border-radius: 10px;
          border: none;
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          color: #050E1A;
          font-size: 0.85rem;
          font-weight: 700;
          font-family: 'Cinzel', serif;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          white-space: nowrap;
          cursor: pointer;
          box-shadow: 0 4px 16px rgba(254, 161, 22, 0.35);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .hk-callback-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #ff9500 0%, #fea116 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 22px rgba(254, 161, 22, 0.5);
        }

        .hk-callback-btn:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }

        .hk-thank-title {
          color: #0B1D37;
          font-weight: 700;
          font-family: 'Cinzel', serif;
        }

        /* Responsive grid system */
        @media (max-width: 991px) {
          .hk-callback-card {
            padding: 14px 16px !important;
          }
          .hk-callback-grid {
            grid-template-columns: 1fr 1fr;
            gap: 10px;
          }
          .hk-button-group {
            grid-column: span 2;
          }
          .hk-callback-btn {
            width: 100%;
          }
        }

        @media (max-width: 576px) {
          .hk-callback-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
          .hk-button-group {
            grid-column: span 1;
          }
          .hk-field-input {
            height: 40px;
            font-size: 0.85rem;
          }
          .hk-callback-btn {
            height: 40px;
            font-size: 0.82rem;
          }
        }
      `}</style>
    </section>
  );
}
